module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('section', {
    staticClass: "hero is-primary"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('nav', {
    staticClass: "breadcrumb is-small",
    attrs: {
      "aria-label": "breadcrumbs"
    }
  }, [_c('ul', [_c('li', [_c('router-link', {
    attrs: {
      "to": {
        name: 'home'
      }
    }
  }, [_vm._v("\n              Home\n            ")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": {
        name: 'playlists'
      }
    }
  }, [_vm._v("\n              Playlists\n            ")])], 1), _vm._v(" "), _c('li', {
    staticClass: "is-active"
  }, [_c('a', {
    attrs: {
      "href": "#",
      "aria-current": "page"
    }
  }, [_vm._v("\n              " + _vm._s(_vm.playlistItem.caption || "New") + "\n            ")])])])])])]), _vm._v(" "), _c('section', {
    staticClass: "section"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('playlist-item-edit')], 1)]), _vm._v(" "), _c('BaseActionRoundButton', {
    attrs: {
      "icon-class": _vm.buttonActionIconClass
    },
    on: {
      "click": function($event) {
        return _vm.save()
      }
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-856512d2!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/EditPlaylistItem.vue
// module id = 322
// module chunks = 2